import React from 'react';
import { isPatient } from 'utils/userTypeHelper';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import useUser from 'utils/useUser';
import ActivityRow from './activityRow';

const ActivityTable = ({
  handleCommentSubmit,
  handleReviewedCheck,
  submitCommentLoading,
  actionReviewLoading,
  patient,
  reviewed,
  activity,
}) => {
  const { userType } = useUser();
  const columnNumber = (index) =>
    activity.page * activity.itemsPerPage + index + 1 - activity.itemsPerPage;
  return (
    <Table borderless cellSpacing="0" cellPadding="0">
      <thead>
        <tr className="activity-row-mobile">
          <th className="table-status-column">№</th>
          <th className="table-status-column-mobile"> </th>
          <th className="table-time-column-mobile">Time</th>
          {!isPatient(userType) && (
            <>
              <th className="table-reading-column-mobile">Reading</th>
              {!reviewed && (
                <th className="table-reviewed-column-mobile">Reviewed</th>
              )}
            </>
          )}
        </tr>
      </thead>
      <tbody>
        {activity.data.map((activityRow, index) => (
          <ActivityRow
            key={`${activityRow.id}-${index}`}
            columnNumber={columnNumber(index)}
            activity={activityRow}
            handleCommentSubmit={handleCommentSubmit}
            handleReviewedCheck={handleReviewedCheck}
            reviewed={reviewed}
            setReviewedLoading={actionReviewLoading}
            submitCommentLoading={submitCommentLoading}
            thresholds={patient.thresholds}
          />
        ))}
      </tbody>
    </Table>
  );
};

ActivityTable.propTypes = {
  handleCommentSubmit: PropTypes.func.isRequired,
  handleReviewedCheck: PropTypes.func.isRequired,
  submitCommentLoading: PropTypes.bool.isRequired,
  actionReviewLoading: PropTypes.bool.isRequired,
  patient: PropTypes.shape(),
  activity: PropTypes.shape(),
  reviewed: PropTypes.bool,
};

export default ActivityTable;
